import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, List, ListItem, ListItemText, Box } from '@mui/material';

const InfoDialog = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Product Settings Import Guide</DialogTitle>
            <DialogContent>
                <Typography variant="body1" paragraph>
                    This functionality allows you to import product settings from a CSV file. Here&apos;s how to use it:
                </Typography>
                <List>
                    <ListItem>
                        <ListItemText
                            primary="1. Prepare your CSV file"
                            secondary={
                                <Box component="span">
                                    <Typography variant="body2" component="div">
                                        Ensure your CSV file contains the correct columns and data format as specified in the template.
                                    </Typography>
                                    <Typography variant="body2" component="div" sx={{ mt: 1 }}>
                                        The columns are:
                                    </Typography>
                                    <Box component="ul" sx={{ mt: 0.5, mb: 1, pl: 2 }}>
                                        <li><Typography variant="body2">distributor - the SAP ID of the distributor, e.g. &apos;001OBC&apos;</Typography></li>
                                        <li><Typography variant="body2">sku - the SKU of the product, e.g. &apos;OA6012&apos;</Typography></li>
                                        <li><Typography variant="body2">offeringStatus - one of &apos;Everyday&apos;, &apos;Limited Release&apos;, &apos;New Item&apos;, &apos;Not Offered&apos;</Typography></li>
                                        <li><Typography variant="body2">fulfillmentMethod - one of &apos;Replenishable&apos;, &apos;Order Only&apos;, &apos;Indirect&apos;, &apos;Removed&apos;, &apos;Planning Window&apos;, &apos;Cap&apos;</Typography></li>
                                        <li><Typography variant="body2">directDistributor - required only if fulfillmentMethod is &apos;Indirect&apos;</Typography></li>
                                    </Box>
                                    <Typography variant="body2" component="div" sx={{ mt: 1 }}>
                                        Additional notes:
                                    </Typography>
                                    <Box component="ul" sx={{ mt: 0.5, mb: 1, pl: 2 }}>
                                        <li><Typography variant="body2">The file can be edited in any text editor or Excel</Typography></li>
                                        <li><Typography variant="body2">The headers should be in the first row of the file and match exactly the columns specified above</Typography></li>
                                        <li><Typography variant="body2">The headers and values are automatically trimmed of whitespace</Typography></li>
                                        <li><Typography variant="body2">The headers, offeringStatus and fulfillmentMethod are case-sensitive</Typography></li>
                                        <li><Typography variant="body2">The changes will only be applied if there are no errors in the file</Typography></li>
                                    </Box>
                                </Box>
                            }
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="2. Upload the file"
                            secondary="Click the &apos;Upload Settings&apos; button and select your prepared CSV file."
                        />
                    </ListItem>
                    <ListItem>
                        <ListItemText
                            primary="3. Review and confirm"
                            secondary="After selecting the file, click &apos;Upload&apos; to process the import."
                        />
                    </ListItem>
                </List>
                <Typography variant="body2" color="text.secondary">
                    Note: The system will validate your data and show any errors that need to be corrected.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

InfoDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};

export default InfoDialog; 